module.exports = __webpack_public_path__ + "img/40_69_007_620.446c7f79.jpg";